var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled from 'styled-components';
import { MemberRoles as Roles, memberStatus as MemberStatus, } from '../../types/members';
import { MembersPageTestId } from '../testId';
import Popover from '@doordash/component-popover';
import ListCell from '@doordash/component-list-cell';
import { IconButton } from '@doordash/component-button';
import { Text, BorderRadius, Colors } from '@doordash/design-language';
import { DV2_NAMES, dv2Defaults } from '../DV2';
import { useDVSBoolean } from '@doordash/lib-dvs-client/lib/react';
import MembersStrings from './MembersStrings';
var PopoverContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 200px;\n  border-radius: ", "px;\n"], ["\n  min-width: 200px;\n  border-radius: ", "px;\n"])), BorderRadius.Medium);
export var EmployeeListActionMenu = function (_a) {
    var member = _a.member, onRemoveMemberClick = _a.onRemoveMemberClick, currentTeamMember = _a.currentTeamMember, onToggleAdminAccess = _a.onToggleAdminAccess, handleResendIndividualInvites = _a.handleResendIndividualInvites;
    var isMembershipActivationRemindersEnabled = useDVSBoolean(DV2_NAMES.ddfwMembershipActivationReminder, dv2Defaults.ddfwMembershipActivationReminder);
    var _b = __read(React.useState(false), 2), isPopoverVisible = _b[0], setIsPopoverVisible = _b[1];
    var isMemberCurrentUser = member.id === currentTeamMember.id;
    var isMemberAdmin = member.roles && member.roles.includes(Roles.ADMIN);
    var contentStrings = MembersStrings.employeeListActionMenu;
    var menuOptions = [
        {
            key: 'remove-member',
            title: contentStrings.menuOptionRemoveEmployee(),
            testId: MembersPageTestId.RemoveEmployee,
            isDisabled: isMemberCurrentUser,
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                onRemoveMemberClick(member);
            },
        },
    ];
    if (!isMemberCurrentUser && member.status === MemberStatus.ACTIVE) {
        var title = isMemberAdmin
            ? contentStrings.menuOptionRemoveAdmin()
            : contentStrings.menuOptionGrantAdmin();
        var testId = isMemberAdmin
            ? MembersPageTestId.RevokeAdminAccess
            : MembersPageTestId.GrantAdminAccess;
        menuOptions.unshift({
            key: 'toggle-admin-access',
            title: title,
            testId: testId,
            isDisabled: false,
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                onToggleAdminAccess(member);
            },
        });
    }
    if (isMembershipActivationRemindersEnabled &&
        !isMemberCurrentUser &&
        member.status === MemberStatus.PENDING) {
        var selectedTeamMemberId_1 = member.id;
        var emails_1 = new Array(member.email);
        menuOptions.unshift({
            key: 'resend-join-invite',
            title: contentStrings.menuOptionResendInvite(),
            testId: MembersPageTestId.ResendIndividualJoinInvite,
            isDisabled: false,
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                handleResendIndividualInvites(selectedTeamMemberId_1, emails_1);
            },
        });
    }
    var dismissPopover = function () { return setIsPopoverVisible(false); };
    React.useEffect(function () {
        document.addEventListener('click', dismissPopover);
        return function () {
            document.removeEventListener('click', dismissPopover);
        };
    });
    return (React.createElement(Popover, { position: Popover.Positions.BottomRight, interactionType: Popover.InteractionTypes.Controlled, showContainerPointer: false, isVisible: isPopoverVisible, content: React.createElement(PopoverContainer, null, menuOptions.map(function (option) { return (React.createElement(ListCell, { isSeparatorVisible: true, key: option.key, title: option.title, titleOverrides: {
                size: Text.Sizes.S16,
                color: option.isDisabled
                    ? Colors.ButtonFabForegroundDisabled
                    : '',
            }, onClick: option.isDisabled ? null : option.onActionClick, "data-testid": option.testId })); })) }, function (_a) {
        var describedBy = _a.describedBy;
        return (React.createElement(IconButton, { accessibilityLabel: "Actions", accessibilityDescribedBy: describedBy, iconType: IconButton.IconTypes.MoreHorizontal, onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                setIsPopoverVisible(!isPopoverVisible);
            }, "data-testid": MembersPageTestId.MembersMenuButton }));
    }));
};
var templateObject_1;
